module.exports = __webpack_public_path__ + "img/switcheo-light.59dc7c61.svg";